import { FuseAnimate } from '@fuse';
import _ from '@lodash';
import { Checkbox, Typography, withStyles } from '@material-ui/core';
import XAPPButton from 'app/Core/Components/Button/XAPPButton';
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import * as AppActions from 'app/store/actions';
import classNames from 'classnames';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import ReactTable from 'react-table';
import { bindActionCreators } from 'redux';
import * as Actions from './Store/Actions/EmpresaTarefaActions';

const styles = theme => ({
    root: {
        color: theme.palette.text.primary,
        '& select, input': {
            backgroundColor: theme.palette.background.paper + " !important"
        }
    }
});

class EmpresaTarefaList extends XAPPComponent {

    componentDidMount() {
        this.props.list('SELECIONAR', this.props.xappRouteParams, this.props.idparent);
    }

    componentDidUpdate() {
        if (this.props.EmpresaTarefa.error) {
            this.props.showMessage({
                message: this.props.EmpresaTarefa.error,
                variant: 'error'
            });
            this.props.EmpresaTarefa.error = null;
        }
    }

    onChangeCheck = (_AItem) => {
        const { save, xappRouteParams } = this.props;
        if (_AItem.status === 1) _AItem.status = 0; else _AItem.status = 1;
        save(_AItem, xappRouteParams, _AItem.idparent);
    }

    onChangeRemove = (_AItem) => {
        const { remove, xappRouteParams } = this.props;
        remove(_AItem, xappRouteParams, _AItem.idparent);
    }

    getColumns = () => {
        return [
            {
                Header: "",
                width: 40,
                className: "justify-center",
                Cell: row => (
                    <Checkbox
                        className="p-0"
                        checked={row.original.status === 1}
                        tabIndex={-1}
                        disableRipple
                        name="checked"
                        onChange={() => this.onChangeCheck(row.original)}
                        color="default"
                    />
                )
            },
            {
                Header: "Descrição",
                className: "justify-center",
                Cell: row => (
                    <Typography className={classNames("mx-8", row.original.status === 1 && "line-through opacity-50")}>{row.original.descricao}</Typography>
                )
            },
            {
                Header: "Prazo",
                className: "justify-center",
                Cell: row => (
                    <Typography className={classNames("mx-8", row.original.status === 1 && "line-through opacity-50")}>{row.original.prazodescricao}</Typography>
                )
            },
            {
                Header: "Usuário",
                className: "justify-center",
                Cell: row => (
                    <Typography className={classNames("mx-8", row.original.status === 1 && "line-through opacity-50")}>{row.original.usuarionome}</Typography>
                )
            },
            {
                Header: "Criado em",
                className: "justify-center",
                Cell: row => (
                    <Typography className={classNames("mx-8", row.original.status === 1 && "line-through opacity-50")}>{row.original.datainsdescricao}</Typography>
                )
            },
            {
                Header: "",
                width: 40,
                className: "justify-center",
                Cell: row => (
                    <XAPPButton
                        type="icon"
                        className="w-32 h-32 p-0"
                        aria-label="Delete"
                        onClick={() => this.onChangeRemove(row.original)}
                        icon={"delete"}
                        iconProps={"text-16"}
                    />
                )
            }
        ];
    }

    render() {
        const { EmpresaTarefa, classes } = this.props;
        return (
            <div className="table-responsive">
                <FuseAnimate animation="transition.slideUpIn" delay={300}>
                    <ReactTable
                        //className={classNames(classes.root, '-striped -highlight border-0')}
                        className={classNames(classes.root, '-striped -highlight border-0')}
                        data={!_.isNull(EmpresaTarefa.data) ? EmpresaTarefa.data : []}
                        columns={this.getColumns()}
                        defaultPageSize={10}
                        noDataText="Não existem registros cadastrados!"
                    />
                </FuseAnimate>
            </div>
        );
    }
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        list: Actions.list,
        save: Actions.save,
        remove: Actions.remove,
        showMessage: AppActions.showMessage,
    }, dispatch);
}

function mapStateToProps({ EmpresaTarefaApp }) {
    return {
        EmpresaTarefa: EmpresaTarefaApp,
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(EmpresaTarefaList)));
